import { Button, Modal, Typography } from "antd";
import { Image } from "react-bootstrap";
import flowImage from "../../../assets/images/choose-flow.png";
import "./FlowUploadModal.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useModalContainer } from "../../../utilities/Models/modelUtils";
import { useEffect, useState } from "react";
import { ROUTES } from "../../../utilities/Constants/Constants";

const FlowUploadModal = ({ type, isModalOpen, setIsModalOpen }: { type: string, isModalOpen: boolean, setIsModalOpen: () => void }) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const modalContainer = useModalContainer();

  const flowTypes = [
    {
      key: "paragraph",
      name: t('paragraph'),
      icon: flowImage,
      onclick: (e: any) => { goToWorkbench("paragraph"); e.stopPropagation() },
      link: "/workbench/?flow_type=paragraph",
    },
    {
      key: "steps",
      name: t('steps'),
      icon: flowImage,
      onclick: (e: any) => { goToWorkbench("steps"); e.stopPropagation() },
      link: "/workbench/?flow_type=steps",
    },
    {
      key: "yesorno",
      name: t('yesorno'),
      icon: flowImage,
      onclick: (e: any) => { goToWorkbench("yesorno"); e.stopPropagation() },
      link: "/workbench/?flow_type=yesorno",
    },
  ];

  const handleOnClose = () => {
    setIsModalOpen();
  };

  function goToWorkbench(type: any) {
    if (type) {
      setIsModalOpen();
      sessionStorage.setItem('flow_type', type);
      // window.open('/workbench', '_blank');
      navigate(ROUTES.WORK_BENCH)
    } else {
      navigate("/dashboard");
    }
  }
  const [modalWidth, setModalWidth] = useState<any>('auto');

  useEffect(() => {
    const handleResize = () => {
      setModalWidth(window.innerWidth > 1200 ? 882 : 'auto');
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
      <p
        className="card-link ps-0"
      >
        {t('uploadOptions.flowDiagram.title')}
      </p>
      <Modal
        title={false}
        footer={false}
        centered
        open={isModalOpen}
        onCancel={(e: any) => { handleOnClose(); e.stopPropagation() }}
        className="flow-upload-modal"
        width={modalWidth}
        mask={false}
        getContainer={() => modalContainer || document.body}
      >
        <Typography.Title className="modal-title">{t('uploadOptions.flowDiagram.modalTitle')}</Typography.Title>
        <Typography.Paragraph
          ellipsis={{ rows: 4 }}
          className="modal-description pe-5"
        >
          {t('uploadOptions.flowDiagram.modalDescription')}
        </Typography.Paragraph>

        <div className="row flow-cards-wrapper mb-3">
          {flowTypes.map((flow: any) => {
            return (
              <div key={flow.key}
                className="col-md-4 d-flex"
                onClick={flow.onclick}
              >
                <div className="w-100 select-flow-button">
                  <Image src={flow.icon} alt="flow" className="img-fluid" />
                  <Typography.Text className="">{flow.name}</Typography.Text>
                </div>
              </div>
            );
          })}

        </div>
        <div className="d-flex justify-content-end">
          < Button
            className="viewModel-btn mt-2"
            style={{ width: "120px" }}
            onClick={() => navigate(ROUTES.VIEWMODELS)}
          >
            {t("buttons.viewModel")}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default FlowUploadModal;

